<fcom-icon class="icon-medium flex--shrink0 text-icon-primary" [name]="icon()" />
<div class="ps-xsmall-l flex flex--column flex-1">
  <div class="flex flex--space-between">
    <span class="font-body-medium-bold">{{ service().translations?.title }}</span>
    <!--
      Always rendered (never *ngIf'd out): the tag's width is reserved in the layout even when
      hidden, so the title's available width — and therefore how many lines it wraps to — doesn't
      change when the in-cart state toggles, which would otherwise change the row's height.
    -->
    <fcom-tag
      class="flex--self-start ms-xsmall-l"
      [style.visibility]="inCart() ? 'visible' : 'hidden'"
      [theme]="TagTheme.WHITE"
      [attr.data-testid]="'bundle-service-card-in-cart-' + service().category"
    >
      {{ 'ancillaries.bundle.serviceCard.inCartTag' | finLocalization }}
    </fcom-tag>
  </div>
  <span class="font-body-small ms-xxsmall-t">{{ service().translations?.description | finStripHtml }}</span>
  @if (hasModal()) {
    <fcom-link
      class="font-body-small ms-xxsmall-t"
      [attr.data-testid]="'ancillary-bundle-details-' + service().category"
      (afterNavigation)="modalOpen = true"
      >{{ `ancillaries.${service().category}.detailsLinkTitle` | finLocalization }}</fcom-link
    >
  }
</div>

@if (hasModal()) {
  <fin-product-info-modal [open]="modalOpen" [serviceInfo]="service()" (closeModal)="modalOpen = false" />
}
